module.exports = __webpack_public_path__ + "components/rating/static/wreath-e4041645f8232cba9a4534b7cf6749e1.svg";